export enum PropositionPositioningEnum {
  'against' = 'Contra',
  'neutral' = 'Neutro',
  'infavor' = 'A Favor',
}

export type PropositionPositioningKeys = keyof typeof PropositionPositioningEnum
